export default {
    'CN': '中文',
    'EN': '英语',
}